import script from "./FormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormModal.vue?vue&type=script&setup=true&lang=ts"

import "./FormModal.vue?vue&type=style&index=0&id=b76f9f38&lang=scss"

const __exports__ = script;

export default __exports__